import { render } from "./SignUpInvites.vue?vue&type=template&id=b6364ef8&scoped=true"
import script from "./SignUpInvites.vue?vue&type=script&lang=js"
export * from "./SignUpInvites.vue?vue&type=script&lang=js"

import "./SignUpInvites.vue?vue&type=style&index=0&id=b6364ef8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6364ef8"]])

export default __exports__